import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './components/Login';
import ResetPassword from './components/ResetPassword';
import NewDashboard from './components/NewDashboard';
import NewAssistant from './components/NewAssistant';
import EditAssistant from './components/EditAssistant';
import MyAssistants from './components/MyAssistants';
import MyClassicGptAgents from './components/MyClassicGptAgents';
import NewClassicGptAgent from './components/NewClassicGptAgent';
import MyAulas from './components/MyAulas';
import AulasDocentes from './components/AulasDocentes';
import AulaDocenteForm from './components/AulaDocenteForm';
import AulaDocenteAccessPage from './components/AulaDocenteAccessPage';
import ProfesorCreateAula from './components/ProfesorCreateAula';
import ProfesorEditAula from './components/ProfesorEditAula';
import Reports from './components/Reports';
import SelectColegio from './components/SelectColegio';
import AdminSelectColegio from './components/AdminSelectColegio';
import AdminDashboard from './components/AdminDashboard';
import AdminCreateProfesor from './components/AdminCreateProfesor';
import AdminEditProfesor from './components/AdminEditProfesor';
import AdminCreateAlumno from './components/AdminCreateAlumno';
import AdminEditAlumno from './components/AdminEditAlumno';
import AdminCreateAdminArea from './components/AdminCreateAdminArea';
import AdminEditAdminArea from './components/AdminEditAdminArea';
import AdminCreateColegio from './components/AdminCreateColegio';
import AdminCreateColegioAdmin from './components/AdminCreateColegioAdmin';
import AdminCreateProfesorParticular from './components/AdminCreateProfesorParticular';
import AdminEditProfesorParticular from './components/AdminEditProfesorParticular';
import AdminProfesorParticularProfesores from './components/AdminProfesorParticularProfesores';
import AdminEditColegio from './components/AdminEditColegio';
import AdminColegioOpenAIAssistantConfigs from './components/AdminColegioOpenAIAssistantConfigs';
import AdminCreateMateria from './components/AdminCreateMateria';
import AdminEditMateria from './components/AdminEditMateria';
import AdminCreateCurso from './components/AdminCreateCurso';
import AdminEditCurso from './components/AdminEditCurso';
import AdminCreateAula from './components/AdminCreateAula';
import AdminEditAula from './components/AdminEditAula';
import AdminCreateArea from './components/AdminCreateArea';
import AdminEditArea from './components/AdminEditArea';
import AdminCreateDivision from './components/AdminCreateDivision';
import AdminEditDivision from './components/AdminEditDivision';
import AdminCreateAsistente from './components/AdminCreateAsistente';
import AdminEditAsistente from './components/AdminEditAsistente';
import AdminSolicitudesInbox from './components/AdminSolicitudesInbox';
import AdminColegioStats from './components/AdminColegioStats';
import AdminGeneralStats from './components/AdminGeneralStats';
import AdminGeneralErrors from './components/AdminGeneralErrors';
import AdminUsuariosEnLinea from './components/AdminUsuariosEnLinea';
import PresenceTracker from './components/common/PresenceTracker';
import SubjectCardsGrid from './components/SubjectCardsGrid';
import LandingPage from './components/LandingPage';
import AulaPublicPage from './components/AulaPublicPage';
import AulaMessages from './components/AulaMessages';
import MyCursos from './components/MyCursos';
import AlumnoPanel from './components/AlumnoPanel';
import ParticularDashboard from './components/ParticularDashboard';
import ParticularAlumnoPanel from './components/ParticularAlumnoPanel';
import ParticularAulaPage from './components/ParticularAulaPage';
import ParticularAlumnoInvitationRegister from './components/ParticularAlumnoInvitationRegister';
import MensajesInternosInbox from './components/MensajesInternosInbox';
import ParticularChatGPTRouteGuard from './components/common/ParticularChatGPTRouteGuard';
import './App.css';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <PresenceTracker />
        <Router>
          <Routes>
            {/* Ruta pública de login */}
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* Landing */}
            <Route path="/" element={<LandingPage />} />

            {/* Ruta pública de asistentes */}
            <Route path="/chat" element={<SubjectCardsGrid />} />
            <Route path="/aula" element={<AulaPublicPage />} />
            <Route path="/particular/invitacion-alumno" element={<ParticularAlumnoInvitationRegister />} />
            <Route path="/particular/invitacion-alumno/:codigo" element={<ParticularAlumnoInvitationRegister />} />

            {/* Rutas protegidas */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <NewDashboard />
              </ProtectedRoute>
            } />
            
            <Route path="/new-assistant" element={
              <ProtectedRoute>
                <NewAssistant />
              </ProtectedRoute>
            } />
            
            <Route path="/my-assistants" element={
              <ProtectedRoute>
                <MyAssistants />
              </ProtectedRoute>
            } />
            <Route path="/mis-agentes-clasicos-gpt" element={
              <ProtectedRoute>
                <ParticularChatGPTRouteGuard>
                  <MyClassicGptAgents />
                </ParticularChatGPTRouteGuard>
              </ProtectedRoute>
            } />
            <Route path="/mis-agentes-clasicos-gpt/nuevo" element={
              <ProtectedRoute>
                <ParticularChatGPTRouteGuard>
                  <NewClassicGptAgent />
                </ParticularChatGPTRouteGuard>
              </ProtectedRoute>
            } />
            <Route path="/mis-agentes-clasicos-gpt/editar/:assistantId" element={
              <ProtectedRoute>
                <ParticularChatGPTRouteGuard>
                  <NewClassicGptAgent />
                </ParticularChatGPTRouteGuard>
              </ProtectedRoute>
            } />

            <Route path="/my-aulas" element={
              <ProtectedRoute>
                <MyAulas />
              </ProtectedRoute>
            } />

            <Route path="/my-aulas/nuevo" element={
              <ProtectedRoute>
                <ProfesorCreateAula />
              </ProtectedRoute>
            } />

            <Route path="/my-aulas/:aulaId/editar" element={
              <ProtectedRoute>
                <ProfesorEditAula />
              </ProtectedRoute>
            } />

            <Route path="/my-aulas/:aulaId/mensajes" element={
              <ProtectedRoute>
                <AulaMessages />
              </ProtectedRoute>
            } />

            <Route path="/aulas-docentes" element={
              <ProtectedRoute>
                <AulasDocentes />
              </ProtectedRoute>
            } />

            <Route path="/aulas-docentes/nuevo" element={
              <ProtectedRoute>
                <AulaDocenteForm />
              </ProtectedRoute>
            } />

            <Route path="/aulas-docentes/:aulaId/editar" element={
              <ProtectedRoute>
                <AulaDocenteForm />
              </ProtectedRoute>
            } />

            <Route path="/aulas-docentes/:aulaId/ingresar" element={
              <ProtectedRoute>
                <AulaDocenteAccessPage />
              </ProtectedRoute>
            } />

            <Route path="/my-cursos" element={
              <ProtectedRoute>
                <MyCursos />
              </ProtectedRoute>
            } />

            <Route path="/mensajes" element={
              <ProtectedRoute>
                <MensajesInternosInbox />
              </ProtectedRoute>
            } />

            <Route path="/alumno/panel" element={
              <ProtectedRoute>
                <AlumnoPanel />
              </ProtectedRoute>
            } />

            <Route path="/particular" element={
              <ProtectedRoute>
                <ParticularDashboard />
              </ProtectedRoute>
            } />

            <Route path="/particular/alumno-panel" element={
              <ProtectedRoute>
                <ParticularAlumnoPanel />
              </ProtectedRoute>
            } />

            <Route path="/particular/aula/:aulaId" element={
              <ProtectedRoute>
                <ParticularAulaPage />
              </ProtectedRoute>
            } />
            
            <Route path="/assistants/:assistantId/edit" element={
              <ProtectedRoute>
                <EditAssistant />
              </ProtectedRoute>
            } />

            <Route path="/select-colegio" element={
              <ProtectedRoute>
                <SelectColegio />
              </ProtectedRoute>
            } />
            
            <Route path="/reports" element={
              <ProtectedRoute>
                <ParticularChatGPTRouteGuard>
                  <Reports />
                </ParticularChatGPTRouteGuard>
              </ProtectedRoute>
            } />

            <Route path="/admin/select-colegio" element={
              <ProtectedRoute>
                <AdminSelectColegio />
              </ProtectedRoute>
            } />

            <Route path="/admin-dashboard" element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } />

            <Route path="/admin/profesores/nuevo" element={
              <ProtectedRoute>
                <AdminCreateProfesor />
              </ProtectedRoute>
            } />

            <Route path="/admin/profesores/:profesorId/editar" element={
              <ProtectedRoute>
                <AdminEditProfesor />
              </ProtectedRoute>
            } />

            <Route path="/admin/alumnos/nuevo" element={
              <ProtectedRoute>
                <AdminCreateAlumno />
              </ProtectedRoute>
            } />

            <Route path="/admin/alumnos/:alumnoId/editar" element={
              <ProtectedRoute>
                <AdminEditAlumno />
              </ProtectedRoute>
            } />

            <Route path="/admin/admin-area/nuevo" element={
              <ProtectedRoute>
                <AdminCreateAdminArea />
              </ProtectedRoute>
            } />

            <Route path="/admin/admin-area/:adminAreaId/editar" element={
              <ProtectedRoute>
                <AdminEditAdminArea />
              </ProtectedRoute>
            } />

            <Route path="/admin/colegios/nuevo" element={
              <ProtectedRoute>
                <AdminCreateColegio />
              </ProtectedRoute>
            } />

            <Route path="/admin/particulares/nuevo" element={
              <ProtectedRoute>
                <AdminCreateProfesorParticular />
              </ProtectedRoute>
            } />

            <Route path="/admin/particulares/:particularId/editar" element={
              <ProtectedRoute>
                <AdminEditProfesorParticular />
              </ProtectedRoute>
            } />

            <Route path="/admin/particulares/:particularId/profesores" element={
              <ProtectedRoute>
                <AdminProfesorParticularProfesores />
              </ProtectedRoute>
            } />

            <Route path="/admin/colegios/:colegioId/admins/nuevo" element={
              <ProtectedRoute>
                <AdminCreateColegioAdmin />
              </ProtectedRoute>
            } />

            <Route path="/admin/colegios/:colegioId/editar" element={
              <ProtectedRoute>
                <AdminEditColegio />
              </ProtectedRoute>
            } />

            <Route path="/admin/colegios/:colegioId/estadisticas" element={
              <ProtectedRoute>
                <AdminColegioStats />
              </ProtectedRoute>
            } />

            <Route path="/admin/colegios/:colegioId/openai-assistants-config" element={
              <ProtectedRoute>
                <AdminColegioOpenAIAssistantConfigs />
              </ProtectedRoute>
            } />

            <Route path="/admin/metricas-generales" element={
              <ProtectedRoute>
                <AdminGeneralStats />
              </ProtectedRoute>
            } />

            <Route path="/admin/errores-generales" element={
              <ProtectedRoute>
                <AdminGeneralErrors />
              </ProtectedRoute>
            } />

            <Route path="/admin/usuarios-en-linea" element={
              <ProtectedRoute>
                <AdminUsuariosEnLinea />
              </ProtectedRoute>
            } />

            <Route path="/admin/materias/nuevo" element={
              <ProtectedRoute>
                <AdminCreateMateria />
              </ProtectedRoute>
            } />

            <Route path="/admin/materias/:materiaId/editar" element={
              <ProtectedRoute>
                <AdminEditMateria />
              </ProtectedRoute>
            } />

            <Route path="/admin/cursos/nuevo" element={
              <ProtectedRoute>
                <AdminCreateCurso />
              </ProtectedRoute>
            } />

            <Route path="/admin/cursos/:cursoId/editar" element={
              <ProtectedRoute>
                <AdminEditCurso />
              </ProtectedRoute>
            } />

            <Route path="/admin/aulas/nuevo" element={
              <ProtectedRoute>
                <AdminCreateAula />
              </ProtectedRoute>
            } />

            <Route path="/admin/aulas/:aulaId/editar" element={
              <ProtectedRoute>
                <AdminEditAula />
              </ProtectedRoute>
            } />

            <Route path="/admin/areas/nuevo" element={
              <ProtectedRoute>
                <AdminCreateArea />
              </ProtectedRoute>
            } />

            <Route path="/admin/areas/:areaId/editar" element={
              <ProtectedRoute>
                <AdminEditArea />
              </ProtectedRoute>
            } />

            <Route path="/admin/divisiones/nuevo" element={
              <ProtectedRoute>
                <AdminCreateDivision />
              </ProtectedRoute>
            } />

            <Route path="/admin/divisiones/:divisionId/editar" element={
              <ProtectedRoute>
                <AdminEditDivision />
              </ProtectedRoute>
            } />
            
            <Route path="/admin/asistentes/nuevo" element={
              <ProtectedRoute>
                <AdminCreateAsistente />
              </ProtectedRoute>
            } />

            <Route path="/admin/asistentes/:assistantId/editar" element={
              <ProtectedRoute>
                <AdminEditAsistente />
              </ProtectedRoute>
            } />

            <Route path="/admin/solicitudes" element={
              <ProtectedRoute>
                <AdminSolicitudesInbox />
              </ProtectedRoute>
            } />
            
            {/* Ruta de fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </div>
  );
}

export default App;
